/* unplugin-vue-components disabled */import script from "./blknews.vue?vue&type=script&setup=true&lang=js"
export * from "./blknews.vue?vue&type=script&setup=true&lang=js"

import "./blknews.vue?vue&type=style&index=0&id=0586fdbd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0586fdbd"]])

export default __exports__